<template>
    <div>
        <el-form
            label-position="left"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
            class="login-container">
            <el-form-item prop="areaNumber" :error="areaErr">
                <el-select v-model="ruleForm.areaNumber" @change="() => areaErr = ''" style="width: 100%;" :placeholder="$i18n.t('login.text5')">
                    <el-option
                        v-for="item in areaList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="username">
                <el-input
                    type="text"
                    v-model.trim="ruleForm.username"
                    auto-complete="off"
                    :placeholder="$i18n.t('login.text8') + usernameTitle">
                    <template slot="append">
                        <el-button class="code_btn" @click="getCode" :loading="codeBtnLoading"
                                   :disabled="isCodeBtnDisabled">{{ codeBtnMsg }}
                        </el-button>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item prop="code">
                <el-input v-model.trim="ruleForm.code" :placeholder="$i18n.t('login.text9')"></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    :type="isShowPwd1 ? 'text' : 'password'"
                    v-model.trim="ruleForm.password"
                    auto-complete="off"
                    :maxlength="32"
                    :placeholder="$i18n.t('login.text10')">
                    <i slot="suffix" :class="'pwd-icon ' + (isShowPwd1 ? 'icon-buxianzhi' : 'icon-xianzhi')"
                       @click="isShowPwd1 = !isShowPwd1"></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword" :error="error">
                <el-input
                    :type="isShowPwd2 ? 'text' : 'password'"
                    v-model.trim="ruleForm.confirmPassword"
                    auto-complete="off"
                    :maxlength="32"
                    :placeholder="$i18n.t('login.text29')">
                    <i slot="suffix" :class="'pwd-icon ' + (isShowPwd2 ? 'icon-buxianzhi' : 'icon-xianzhi')"
                       @click="isShowPwd2 = !isShowPwd2"></i>
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-checkbox class="remember" v-model="rememberPwd">
                    <span>
                        {{$i18n.t('login.text13')}}
                        <el-link type="primary" href="#/protocol?type=fwxy" target="_blank">{{$i18n.t('login.text14')}}</el-link>
                        {{$i18n.t('login.text16')}}
                        <el-link type="primary" href="#/protocol?type=ysxy" target="_blank">{{$i18n.t('login.text15')}}</el-link>
                    </span>
                </el-checkbox>
            </el-form-item>
            <el-form-item style="width: 100%">
                <el-button
                    type="primary"
                    style="width: 100%;margin-top: 10px;"
                    :loading="registering"
                    @click="register"
                >
                    {{$i18n.t('login.text4')}}
                </el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

import {mapState, mapActions} from "vuex";

export default {

    watch: {
        systemConfig: {
            handler(newVal) {
                this.usernameTitle =
                    (newVal.supportTelephone ? this.$i18n.t('login.text6') : '') +
                    (newVal.supportTelephone && newVal.supportEmail ? '/' : '') +
                    (newVal.supportEmail ? this.$i18n.t('login.text7') : '')
            },
            deep: true
        },
        areaNumberList: {
            handler(newVal) {
                this.areaList = newVal;
                this.ruleForm.areaNumber = this.areaList[0].value
            },
            deep: true
        }
    },

    props: {
        dataCenters: {
            Type: String,
            default: "CN"
        },
        language: {
            Type: String,
            default: "zh"
        },
        systemConfig: {
            Type: Object,
            default: () => ({
                "supportTelephone": true,
                "supportWechat": false,
                "supportMicroApp": false,
                "supportApple": false,
                "supportEmail": false,
                "supportGzh": false
            })
        },
        areaNumberList: {
            Type: Array,
            default: []
        }
    },

    data() {

        //再次输入密码验证
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$i18n.t('login.text30')));
                // password 是表单上绑定的字段
            } else if (value !== this.ruleForm.password) {
                callback(new Error(this.$i18n.t('login.text31')));
            } else {
                callback()
            }
        }


        const validateEmailOrPhone = (rule, value, callback) => {
            const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
            const phoneRegex = /^1[0-9]{10}$/;
            if (this.systemConfig.supportTelephone && this.systemConfig.supportEmail) {
                if (!value) {
                    callback(new Error(this.$i18n.t('login.text17')));
                    return;
                } else if (!emailRegex.test(value) && !phoneRegex.test(value)) {
                    callback(new Error(this.$i18n.t('login.text18')));
                    return;
                }
            } else if (this.systemConfig.supportTelephone) {
                if (!value) {
                    callback(new Error(this.$i18n.t('login.text19')));
                    return;
                } else if (!phoneRegex.test(value)) {
                    callback(new Error(this.$i18n.t('login.text20')));
                    return;
                }
            } else if (this.systemConfig.supportEmail) {
                if (!value) {
                    callback(new Error(this.$i18n.t('login.text21')));
                    return;
                } else if (!emailRegex.test(value)) {
                    callback(new Error(this.$i18n.t('login.text22')));
                    return;
                }
            }
            callback();
        };

        return {

            //定义loading默认为false
            registering: false,

            rememberPwd: false,

            isShowPwd1: false,

            isShowPwd2: false,

            ruleForm: {
                //username和password默认为空
                username: "",
                password: "",
                confirmPassword: "",
                code: "",
                smsId: "",
                areaNumber: ""
            },

            time: 60,

            isCodeBtnDisabled: false,

            codeBtnLoading: false,

            codeBtnMsg: this.$i18n.t('login.text23'),

            //rules前端验证
            rules: {
                username: [
                    {required: true, validator: validateEmailOrPhone }
                ],
                password: [
                    {required: true, message: this.$i18n.t('login.text24'), trigger: "blur"},
                    {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~#^()_\-+={}\[\]:;"'<>,.|\\/])[A-Za-z\d@$!%*?&~#^()_\-+={}\[\]:;"'<>,.|\\/]{8,}$/, message: this.$i18n.t('login.text32')}
                ],
                confirmPassword: [{required: true, validator: validatePass2}],
                code: [{required: true, message: this.$i18n.t('login.text25'), trigger: "blur"}],
                areaNumber: [{required: true, message: this.$i18n.t('login.text5'), trigger: "blur"}]
            },

            error: "",

            areaErr: "",

            usernameTitle: '',

            areaList: []

        }

    },

    methods: {

        ...mapActions('login', ['sendSms', 'isAllowRegistration']),

        /**
         * 重置表单
         */
        initForm() {
            this.error = ""
            this.$refs.ruleForm.resetFields();
            this.ruleForm = {
                //username和password默认为空
                username: "",
                password: "",
                confirmPassword: "",
                code: "",
                smsId: "",
                areaNumber: this.areaList[0].value
            }
        },

        /**
         * 注册
         */
        register() {
            let isStart = true;

            this.$refs.ruleForm.validate((valid) => {
                if (valid && isStart) {
                    if (!this.rememberPwd) {
                        this.$dialog.showMessage(this.$i18n.t('login.text26'), this.$config.TOAST_WARNING);
                        return
                    }
                    this.registering = true;
                    this.error = "";
                    this.$store.dispatch("login/register", {
                        password: this.$md5(this.ruleForm.password),
                        platformType: "2",
                        userName: this.ruleForm.username,
                        smsId: this.ruleForm.smsId,
                        channel: "2",
                        code: this.ruleForm.code,
                        areaNumber: this.ruleForm.areaNumber
                    }).then(res => {
                        this.registering = false;
                        this.$dialog.showMessage(this.$i18n.t('login.text33'), this.$config.TOAST_SUCCESS);
                        this.initForm();
                        this.$emit('registerSuccess');
                        console.log(res);
                    }, err => {
                        this.registering = false;
                        console.log(err);
                        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                    })
                }
            })
        },

        /**
         * 获取验证码
         */
        async getCode() {
            if (!this.ruleForm.areaNumber) {
                this.areaErr = this.$i18n.t('login.text5')
                return
            }
            const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
            const phoneRegex = /^1[0-9]{10}$/;
            if (this.systemConfig.supportTelephone && this.systemConfig.supportEmail) {
                if (!this.ruleForm.username) {
                    return;
                } else if (!emailRegex.test(this.ruleForm.username) && !phoneRegex.test(this.ruleForm.username)) {
                    return;
                }
            } else if (this.systemConfig.supportTelephone) {
                if (!this.ruleForm.username) {
                    return;
                } else if (!phoneRegex.test(this.ruleForm.username)) {
                    return;
                }
            } else if (this.systemConfig.supportEmail) {
                if (!this.ruleForm.username) {
                    return;
                } else if (!emailRegex.test(this.ruleForm.username)) {
                    return;
                }
            }

            let isRegistred = false;
            await this.isAllowRegistration({
                platformType: 2,
                userName: this.ruleForm.username,
                areaNumber: this.ruleForm.areaNumber
            }).catch(err => {
                isRegistred = true;
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            })
            if (isRegistred) {
                return
            }

            this.codeBtnLoading = true;
            this.sendSms({
                phoneCode: this.ruleForm.username,
                type: '1',
                areaNumber: this.ruleForm.areaNumber
            }).then(res => {
                this.ruleForm.smsId = res.result;
                this.countDown();
            }, err => {
                console.log(err);
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            }).finally(() => {
                this.codeBtnLoading = false;
            })
        },

        /**
         * 获取验证码后设置倒计时
         */
        countDown() {
            this.isCodeBtnDisabled = true;
            let language = window.localStorage.getItem('language')
            this.codeBtnMsg = language === 'zh' ? (this.time + "s" + this.$i18n.t('login.text27')) : (this.$i18n.t('login.text27') + this.time + "s")
            let codeTime = setInterval(() => {
                this.time--;
                this.codeBtnMsg = language === 'zh' ? (this.time + "s" + this.$i18n.t('login.text27')) : (this.$i18n.t('login.text27') + this.time + "s")
                if (this.time < 0) {
                    this.time = 60;
                    this.codeBtnMsg = this.$i18n.t('login.text28')
                    this.isCodeBtnDisabled = false;
                    clearInterval(codeTime);
                }
            }, 1000)
        }

    }

}
</script>

<style scoped>
.login-container {
    width: 80%;
    margin: 5% auto;
}

.text-link {
    color: #1C204F;
}

.remember {
    float: left;
    margin-bottom: -23px;
    margin-top: -10px;
}

.code_btn {
    font-size: 10px;
    padding: 0 10px;
}

/deep/ .el-checkbox__label {
    display: inline-grid;
    white-space: pre-line;
    word-wrap: break-word;
    overflow: hidden;
    text-align: left;
}

.pwd-icon {
    font-size: 14px;
    color: #757575;
    font-family: "iconfont" !important;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-right: 10px;
    cursor: pointer;
}
</style>
